import styled from '@emotion/styled';
import { Paragraph2 } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

export const SectionHeader = styled.div<{ border?: boolean }>`
  padding: 16px 0;
  margin: 0 12px;
  border-bottom: ${(props) => props.border && `1px solid ${colors.gray200}`};
`;

export const CheckoutInquiry = styled(Paragraph2)`
  cursor: pointer;
`;

export const SectionBody = styled.div`
  padding: 8px 12px 0;
  margin-bottom: 12px;
`;

export const Buttons = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: -16px;

  .p-grid-col {
    padding: 4px;
    flex: 0 0 calc(100% / 3);
    max-width: calc(100% / 3);
  }

  button {
    width: 100%;
    height: 56px !important;
  }
`;

export const PayTypeIcon = styled.div<{ src: string }>`
  width: 100%;
  height: 100%;
  min-width: 78px;

  background-image: url(${(props) => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const Button = styled.button<{ checked: boolean }>`
  border-radius: 8px;
  min-height: 36px;
  border: 1px solid var(--color-ui-grayscale-gray-200) !important;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  position: relative;
  height: 56px;
  user-select: none;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: fit-content;
    padding: 2px 0px;
    white-space: nowrap;
    color: var(--color-ui-grayscale-black) !important;
  }

  transition: 0.1s opacity ease;

  :hover {
    opacity: 0.6;
  }

  :active {
    opacity: 1;
  }

  ${(props) =>
    props.checked &&
    `
      border-color: var(--color-ui-grayscale-black) !important;
      font-weight: 600;
    `}
`;

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .input-wrapper,
  .select-wrapper,
  .input-area-wrapper {
    margin: 0;
  }

  .input-wrapper .guide {
    margin: 0;
  }
`;
